import { ConfigContext, IConfigProps } from './context/ConfigContext';
import ReactDOM from 'react-dom/client';
import Cookies from 'js-cookie';
import { StateProvider } from './providers/StateProvider';
import { initialState } from './store/InitialState';
import { reducer } from './store/Reducer';
import { LoggerContextProvider } from './context/LoggerContext';
import UserProvider from './providers/UserProvider';
import ValidationProvider from './providers/ValidationProvider';
import PackageProvider from './providers/PackageProvider';
import GiftCardProvider from './providers/GiftCardProvider';
import FlowProvider from './providers/FlowProvider';
import App from './App';
import VehicleProvider from './providers/VehicleProvider';
import { deleteCache } from './helpers/shared';

/* istanbul ignore next */
let context = (window as any) || {};

context.OnsaFlowTemplate = (function () {
    function boostrapApplication(config: IConfigProps, boostrapElement: any) {
        const logEndpoint = window.topContext.config.getEndpointConfig().logger;
        const root = ReactDOM.createRoot(boostrapElement);

        root.render(
            <StateProvider reducer={reducer as any} initialState={initialState}>
                <ConfigContext.Provider value={config}>
                    <LoggerContextProvider values={[logEndpoint, config.appName, config.logLevel]}>
                        <ValidationProvider>
                            <UserProvider>
                                <VehicleProvider>
                                    <FlowProvider>
                                        <PackageProvider>
                                            <GiftCardProvider>
                                                <App />
                                            </GiftCardProvider>
                                        </PackageProvider>
                                    </FlowProvider>
                                </VehicleProvider>
                            </UserProvider>
                        </ValidationProvider>
                    </LoggerContextProvider>
                </ConfigContext.Provider>
            </StateProvider>
        );
    }

    if (Cookies.get('nummerplade')) {
        deleteCache();
    }
    return boostrapApplication;
})();
